import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {

  constructor(private _httpClient: HttpClient, private _utilitiesService: UtilitiesService) { }

  loadMemberships() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Membership', this._utilitiesService.httpConfig);
  }

  cancelMemberships(membershipId: string) {
    return this._httpClient.patch(this._utilitiesService.getAPIUrl() + 'Membership/' + membershipId, this._utilitiesService.httpConfig);
  }

  loadOrganisations() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Organisation', this._utilitiesService.httpConfig);
  }

  loadOrganisationsFlat() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Organisation/Flat', this._utilitiesService.httpConfig);
  }

  loadMainOrganisationsId() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Organisation/MainOrg', this._utilitiesService.httpConfig);
  }

  createMemberships(organisationIds: string[]) {
    return this._httpClient.post(this._utilitiesService.getAPIUrl() + 'Membership', organisationIds, this._utilitiesService.httpConfig);
  }
}
